import React from "react";
import {CheckBoxOptionalGroup} from "modules/connectors/components/OptionalGroup";
import {useSelector} from "react-redux";
import { useTranslation} from 'react-i18next';
import { connectorsettings as i18nNamespace} from "../../../../i18n/namespace";

const infoText = (t) => {
    return {
        usePrivateLink: t("use_private_link"),
        overrideCifsLocks: t("override_cifs_locks")
    }
}

const AzureCifsTitle = () => {
    const configValue = useSelector(state => state.connectorSettings.settings.config.overrideCifsLocks);
    const { t } = useTranslation(i18nNamespace);
    return {
        title: t("azure_CIFS_locks"),
        value: configValue ? t("on") : t("off"),
        tooltip: infoText(t).overrideCifsLocks
    }
}

const AzureCifsContent = ({close: closeOptionalGroup}) => {
    const { t } = useTranslation(i18nNamespace);
    return <CheckBoxOptionalGroup closeOptionalGroup={closeOptionalGroup} configKey='overrideCifsLocks'
                                  text={t("override_CIFS_locks")}/>
};

const AzurePrivateLinkTitle = () => {
    const configValue = useSelector(state => state.connectorSettings.settings.config.usePrivateLink);
    const { t } = useTranslation(i18nNamespace);
    return {
        title: t("azure_preivate_link"),
        value: configValue ? t("on") : t("off"),
        tooltip: infoText(t).usePrivateLink
    }
}

const AzurePrivateLinkContent = ({close: closeOptionalGroup}) => {
    const { t } = useTranslation(i18nNamespace);
    return <CheckBoxOptionalGroup closeOptionalGroup={closeOptionalGroup} configKey='usePrivateLink'
                                  text={t("private_link_connection_cvo")}/>
};

export const AzurePrivateLink = {
    Title: AzurePrivateLinkTitle,
    Content: AzurePrivateLinkContent
}

export const AzureCifs = {
    Title: AzureCifsTitle,
    Content: AzureCifsContent
}